import Hls from "hls.js";

export interface Player {
  destroy(): void;
}

/**
 * Attach an HLS source to a video element. Prefers native HLS (Safari/iOS),
 * falls back to hls.js. Tuned for robustness over latency (PRD §9): a generous
 * forward buffer rides out jitter on a weak link — the guest being a few seconds
 * behind "live" is invisible since nobody is racing.
 */
export function attachHls(video: HTMLVideoElement, src: string): Player {
  if (video.canPlayType("application/vnd.apple.mpegurl")) {
    video.src = src;
    return {
      destroy() {
        video.removeAttribute("src");
        video.load();
      },
    };
  }

  if (Hls.isSupported()) {
    const hls = new Hls({
      maxBufferLength: 30,
      maxMaxBufferLength: 120,
      backBufferLength: 30,
      lowLatencyMode: false,
    });
    hls.loadSource(src);
    hls.attachMedia(video);
    return {
      destroy() {
        hls.destroy();
      },
    };
  }

  throw new Error("HLS is not supported in this browser");
}
